var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-audio"},[_c('div',{staticClass:"audio message-text__wrap"},[_c('audio',{attrs:{"src":_vm.url,"controls":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }